import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const getTermsAccepted = (appName) => {
  return base.get({
    url: API_PARAM.TERMS_ACCEPTED,
    params: { moduleName: appName}
  });
};

export const getTermsContent = (appName) => {
  return base.get({
    url: API_PARAM.TERMS_CONTENT,
    params: { moduleName: appName}
  });
};

export const setTermsAccept = (appName) => {
  return base.post({
    url: API_PARAM.TERMS_ACCEPT,
    nonceHeader: true,
    data : { moduleName: appName}
  });
};

export const getPrivacyAccepted = (appName) => {
  return base.get({
    url: API_PARAM.PRIVACY_ACCEPTED,
    params: { moduleName: appName}
  });
};

export const getPrivacyContent = (appName) => {
  return base.get({
    url: API_PARAM.PRIVACY_CONTENT,
    params: { moduleName: appName}
  });
};

export const setPrivacyAccept = (appName) => {
  return base.post({
    url: API_PARAM.PRIVACY_ACCEPT,
    nonceHeader: true,
    data : { moduleName: appName}
  });
};
